import React from 'react'

const Button = (props) => {
  return (
    <button
      id={props.id}
      className={`text--white btn`}
      onClick={props.onClick}
      style={props.style}
      disabled={props.disabled}
    >
      {props.content}
    </button>
  )
}

export default Button


// WEBPACK FOOTER //
// ./src/components/Button.js